import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { GlobalService } from 'src/app/app-core/lib/global.service';
import { DashboardService } from 'src/app/app-core/services/dashboard.service';
import { DepartmentService } from 'src/app/app-core/services/department.service';
import { UserService } from 'src/app/app-core/services/user.service';
import { OrganizationService } from 'src/app/app-core/services/organization.service';
import { IDepartment } from 'src/app/interfaces/department';
import { IListScopeDepartmentResponse } from 'src/app/interfaces/listScope/listScopeDepartmentResponse';
import { FilterService, IDashboardFilters } from 'src/app/app-core/services/filter.service';
import { Dropdown } from 'primeng/dropdown';
import { IOrganization } from 'src/app/interfaces/organization';
import { IListScopeOrganizationResponse } from 'src/app/interfaces/listScope/listScopeOrganizationResponse';
import { GerinusBD } from 'src/app/app-core/lib/gerinus-bd.component';
import { Observable, forkJoin } from 'rxjs';
import { ProcessService } from 'src/app/app-core/services/process.service';
import { ApplicantRequestService } from 'src/app/app-core/services/applicant-request.service';
import { RequestService } from 'src/app/app-core/services/request.service';

@Component({
  selector: 'dashboard-admin',
  templateUrl: './dashboard-admin.component.html',
  styleUrls: ['../../pages/dashboard/dashboard.component.scss', './dashboard-admin.component.scss'],
  providers: [
    DashboardService,
    UserService,
    FilterService,
    OrganizationService,
    ProcessService
  ],
})
export class DashboardAdminComponent extends GerinusBD implements OnInit {

  constructor(
    public global: GlobalService,
    private activatedRoute: ActivatedRoute,
    public dashboardService: DashboardService,
    private filterService: FilterService,
    private router: Router,
    public departmentService: DepartmentService,
    public userService: UserService,
    public organizationService: OrganizationService,
    public processService: ProcessService,
    public requestService: RequestService,
    public applicantRequestService: ApplicantRequestService
  ) {
    super(global, dashboardService);
  }

  public requestsAmount: number;
  public processAmount: number;
  public organizationsAmount: number;
  public usersAmount: number;
  public screeningProcess: number;
  public unassignedProcesses: number;
  // FILTROS
  public isFiltersModalOpen: boolean = false;
  public departments: IDepartment[];
  public selectedDepartments: any;
  public dashboardFilters: IDashboardFilters;
  public organizations: IOrganization[] | undefined;
  public selectedOrganization: string;
  public organizationSelectedName = '';
  public departmentSelectedName = '';
  public availableCards = [
    { label: 'Total de Solicitações', value: 'requestsAmount' },
    { label: 'Total de Processos', value: 'processAmount' },
    { label: 'Total de Órgãos', value: 'organizationsAmount' },
    { label: 'Total de Usuários', value: 'usersAmount' },
    { label: 'Processos em Triagem', value: 'screeningProcess' },
    { label: 'Processos sem Atribuição', value: 'unassignedProcesses' },
  ];

  public tempSelectedCards: string[] = this.availableCards.map(card => card.value);
  public selectedCards: string[] = [...this.tempSelectedCards];
  public isFilterApplied: boolean = false;

  async ngOnInit() {
    this.getData();
    this.getDepartments();
    this.getOrganizations();
  }

  public getData() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.selectedDepartments = params['department'] || '';
      this.selectedOrganization = params['organization'] || '';

      let whereProcess = '';
      let whereOrganization = '';
      let whereUsers = '';
      let whereUnassignedProcess = '';
      let whereScreeningProcess = '';
      let whereProcessDepartments = '';
      let whereProcessDepartmentsScreeningProcess = '';
      let whereProcessDepartmentsUnassignedProcess = '';

      if (this.selectedOrganization) {
        whereProcess += ` AND "SOL_CodigoOrgao" = ${this.selectedOrganization} `;
        whereOrganization += `"OR_CodigoOrgao" = ${this.selectedOrganization}`;
        whereUsers += `"USR_CodigoOrgao" = ${this.selectedOrganization}`;
        whereUnassignedProcess += `"SOL_CodigoOrgao" = ${this.selectedOrganization}`;
        whereScreeningProcess += `"SOL_CodigoOrgao" = ${this.selectedOrganization}`;
      }

      if (this.selectedDepartments) {
        whereProcessDepartments += ` AND "PRT_DepartamentoAtual" = ${this.selectedDepartments} `;
        whereUsers += ` AND "PE_CodigoDepartamento" = ${this.selectedDepartments}`;
        whereProcessDepartmentsScreeningProcess += ` AND "PRT_DepartamentoAtual" = ${this.selectedDepartments} `;
        whereProcessDepartmentsUnassignedProcess += ` AND "PRT_DepartamentoAtual" = ${this.selectedDepartments} `;
      }

      const finalWhereScreeningProcess = whereProcessDepartmentsScreeningProcess && whereScreeningProcess
        ? `${whereScreeningProcess} ${whereProcessDepartmentsScreeningProcess}`
        : whereScreeningProcess + whereProcessDepartmentsScreeningProcess;

      const finalWhereUnassignedProcess = whereProcessDepartmentsUnassignedProcess && whereUnassignedProcess
        ? `${whereUnassignedProcess} ${whereProcessDepartmentsUnassignedProcess} AND `
        : whereProcessDepartmentsUnassignedProcess;

      this.getCount(
        'processAmount',
        'processService',
        `"PRT_DataFim" IS NULL ${whereProcess} ${whereProcessDepartments}`,
      );

      this.getCount(
        'requestsAmount',
        'requestService',
        `"SOL_CodigoSolicitacao" IS NOT NULL ${whereProcess}`
      );

      this.getCount(
        'organizationsAmount',
        'organizationService',
        whereOrganization
      );

      this.getCount(
        'usersAmount',
        'userService',
        whereUsers
      );

      const combinedWhere = finalWhereScreeningProcess
      ? `"createdByGroup" = 'TRIAGEM' AND (${finalWhereScreeningProcess})`
      : `"createdByGroup" = 'TRIAGEM'`;

      this.getCountScreeningUnassignedProcess(
        'screeningProcess',
        'processService',
        combinedWhere
      );

      this.getCountScreeningUnassignedProcess(
        'unassignedProcesses',
        'processService',
        whereProcessDepartmentsUnassignedProcess
          ? finalWhereUnassignedProcess + `"PRC_CodigoResponsavel" IS NULL`
          : `"PRC_CodigoResponsavel" IS NULL`
      );
    });
  }

  public getCountScreeningUnassignedProcess(variableName: string, service: string, where = '') {
    this.dashboardService.getTotalObservableScreeningProcess(service, where).subscribe({
      next: (response: any) => {
        const dataWithGroup = response.data.map((item: any) => ({
          ...item,
          createdByGroup: 'TRIAGEM'
        }));
  
        this[variableName] = dataWithGroup.length;
      }
    });
  }

  public getCount(variableName: string, service: string, where = '') {
    this.dashboardService.getTotalObservable(service, where).subscribe({
      next: (response: any) => {
        this[variableName] = response.data.length;
      }
    });
  }

  public filter() {
    this.dashboardFilters = {
      department: this.selectedDepartments,
      organization: this.selectedOrganization,
    };

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: this.dashboardFilters,
      queryParamsHandling: 'merge',
    });

    if (this.tempSelectedCards.length === 0) {
      this.selectedCards = this.availableCards.map(card => card.value);
    } else {
      this.selectedCards = [...this.tempSelectedCards];
    }
    this.isFilterApplied = true;

    this.listAll();

  }

  clearFilters() {
    this.selectedDepartments = null;
    this.selectedOrganization = null;
    this.tempSelectedCards = [];
    this.selectedCards = [];
    this.isFilterApplied = false;

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {},
    });

    this.listAll();
    this.isFiltersModalOpen = false;
  }

  fetchAllDashboardFiltered() {
    this.selectedCards = [...this.tempSelectedCards];
    this.listAll();
    this.filter();
    this.isFiltersModalOpen = false;
  }

  getDepartments() {
    let where = '';
    if (this.selectedOrganization) {
      where = `"DEP_CodigoOrgao" = ${this.selectedOrganization}`;
    }

    this.departmentService.listAll(where, 0).subscribe({
      next: (response: IListScopeDepartmentResponse) => {
        this.departments = response.data;
      }
    });
  }

  getOrganizations() {
    this.organizationService.listAll('', 0).subscribe({
      next: (response: IListScopeOrganizationResponse) => {
        this.organizations = response.data;
      }
    });
  }

  restoreFilterValues() {
    const org = this.organizations.find(org => org.OR_CodigoOrgao == this.selectedOrganization);
    this.organizationSelectedName = org ? org.OR_Descricao : '';

    const dep = this.departments.find(dep => dep.DEP_CodigoDepartamento == parseInt(this.selectedDepartments, 10));
    this.departmentSelectedName = dep ? dep.DEP_Descricao : '';

    this.selectedOrganization = org?.OR_CodigoOrgao || null;
    this.selectedDepartments = dep?.DEP_CodigoDepartamento || null;
  }

  changeOrganization() {
    const organizationName = this.organizations.find(org => org.OR_CodigoOrgao == this.selectedOrganization);
    this.organizationSelectedName = organizationName.OR_Descricao;
    this.getDepartments();
  }

  changeDepartaments() {
    const dapartmentName = this.departments.find(dep => dep.DEP_CodigoDepartamento == parseInt(this.selectedDepartments, 10));
    this.departmentSelectedName = dapartmentName.DEP_Descricao;
  }

  public isCardVisible(card: string): boolean {
    if (!this.isFilterApplied || this.selectedCards.length === 0) {
      return true;
    }

    return this.selectedCards.includes(card);
  }

  private combineWhere(conditionA: string, conditionB: string): string {
    if (conditionA && conditionB) {
      return `${conditionA} AND (${conditionB})`;
    } else if (conditionA) {
      return conditionA;
    } else if (conditionB) {
      return conditionB;
    }
    return '';
  }

  generateDashboardListPDF() {
    const selected = this.selectedCards;

    const filtersUSR = this.selectedOrganization && this.selectedDepartments
      ? `"OR_CodigoOrgao" = ${this.selectedOrganization} AND "DEP_CodigoDepartamento" = ${this.selectedDepartments}`
      : '';

    const filtersOR = this.selectedOrganization
      ? `"OR_CodigoOrgao" = ${this.selectedOrganization}`
      : '';

    const filtersUP = this.selectedDepartments
      ? `"PRT_DepartamentoAtual" = ${this.selectedDepartments} AND "PRC_CodigoResponsavel" IS NULL`
      : '';

    const filtersSP = this.selectedDepartments
      ? `"PRT_DepartamentoAtual" = ${this.selectedDepartments} AND "PRC_NumeroProcesso" IS NOT NULL`
      : '';

    const filtersPRC = this.selectedDepartments
      ? `"PRT_DepartamentoAtual" = ${this.selectedDepartments}`
      : '';

    const filtersSOL = this.selectedOrganization
      ? `"SOL_CodigoOrgao" = ${this.selectedOrganization} AND "SOL_CodigoSolicitacao" IS NOT NULL`
      : `"SOL_CodigoSolicitacao" IS NOT NULL`;

    const cards: any = {};

    if (selected.includes('usersAmount')) {
      cards.usuario = this.userService.listAll(filtersUSR, 0);
    }

    if (selected.includes('organizationsAmount')) {
      cards.orgao = this.organizationService.listAll(filtersOR, 0);
    }

    if (selected.includes('unassignedProcesses')) {
      const combinedUP = this.combineWhere(filtersPRC, `"PRC_CodigoResponsavel" IS NULL`);
      cards.unassignedProcess = this.processService.listAll(combinedUP, 0);
    }

    if (selected.includes('screeningProcess')) {
      const combinedSP = this.combineWhere(`"createdByGroup" = 'TRIAGEM'`, filtersSP);
      cards.screeningProcess = this.processService.listAll(combinedSP, 0);
    }

    if (selected.includes('requestsAmount')) {
      cards.requests = this.requestService.listAll(filtersSOL, 0);
    }

    if (selected.includes('processAmount')) {
      cards.process = this.processService.listAll(filtersPRC, 0);
    }

    forkJoin(cards).subscribe({
      next: (response: any) => {
        this.dashboardService.generateListPDF(response);
      },
    });
  }
}